const SELECT_COMMUNITY_CONTENT_FILTER = (state, payload) => {
  state.communityDetails.communityContentFilter = {
    ...state.communityDetails.communityContentFilter,
    ...payload,
  };
};

export default SELECT_COMMUNITY_CONTENT_FILTER;
